import React, { useEffect, useState } from "react";
import { fetchDoctorById } from "../../../../redux/Thunk/Doctor/DoctorThunks";
import { useDispatch, useSelector } from "react-redux";
import {
  setDoctorById,
  setSearchDoctor,
} from "../../../../redux/Reducer/Doctor/DoctorSlice";
import CheckedBg from "../../../common/icons/CheckedBg";
import Close from "../../../common/icons/Close";
import Timing from "../../../common/icons/Timing";
import ArrowDown from "../../../common/icons/ArrowDown";
import CloseBorder from "../../../common/icons/CloseBorder";
import toast from "react-hot-toast";
import { useOutsideClick } from "../../../common/useOutsideClick";

const SearchSelectDoctor = (props) => {
  const { formik, doctors, type, selectedDoctor, setSelectedDoctor } = props;
  const setFieldValue = formik ? formik.setFieldValue : null;

  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const dispatch = useDispatch();

  const doctorList = useSelector((state) => state?.doctor?.doctorsNotAssigned);
  const doctorById = useSelector((state) => state?.doctor?.doctorById);

  const [filteredDoctors, setFilteredDoctors] = useState([]);

  const handleClickOutside = (event) => {
    if (
      dropdownRef?.current &&
      !dropdownRef?.current?.contains(event?.target)
    ) {
      setIsOpen(false);
    }
  };
  const dropdownRef = useOutsideClick(handleClickOutside);

  useEffect(() => {
    if (!Object.keys(doctorById).length) {
      setSelectedDoctor("");
    }
  }, [doctorById, setSelectedDoctor]);
  useEffect(() => {
    const allDoctors = doctors?.length > 0 ? doctors : doctorList || [];

    // Filter doctors only if a searchTerm is provided, otherwise use allDoctors
    const filterDoctors = searchTerm
      ? allDoctors.filter(
          (doctor) =>
            doctor?.personalInfo?.name
              ?.toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            doctor?.personalInfo?.clinicName
              ?.toLowerCase()
              .includes(searchTerm.toLowerCase())
        )
      : allDoctors;

    setFilteredDoctors(filterDoctors);
  }, [doctors, doctorList, searchTerm]);

  const handleToggleDropdown = () => {
    setIsOpen((prev) => {
      const newState = !prev;
      if (!newState) return newState;
      setTimeout(() => {
        const input = document.getElementById("search");
        input?.focus();
      }, 0);
      return newState;
    });
  };

  const handleSelectDoctor = async (doctor) => {
    setSelectedDoctor(doctor);
    if (type === "listing") {
      const response = await dispatch(
        fetchDoctorById({ doctorId: doctor?.DID })
      ).unwrap();

      if (response?.status === 200 || response.status === 201) {
        setFieldValue("doctorDetails.DID", doctor?.DID);
      } else {
        toast.error(response.message);
      }
    } else if (type === "integration") {
      dispatch(setDoctorById(doctor));
      setSelectedDoctor(doctor);
    }
    dispatch(setSearchDoctor(true));

    setIsOpen(false);
  };
  const handleClearSearch = (e) => {
    dispatch(setDoctorById({}));
    e.stopPropagation();
    setIsOpen(false);
  };
  return (
    <div className="relative" onClick={(e) => e.stopPropagation()}>
      <div
        ref={dropdownRef}
        onClick={handleToggleDropdown}
        className="p-4 bg-gray-100 text-gray-700 border border-gray-300 rounded-lg cursor-pointer flex items-center justify-between"
      >
        {Object.keys(selectedDoctor)?.length > 0 ? (
          <div className="flex items-center gap-3">
            <div className="w-[20px] h-[20px]">
              {selectedDoctor?.currentDoctorStatus ? (
                selectedDoctor?.currentDoctorStatus === "ACTIVE" ? (
                  <CheckedBg fill="#00C732" />
                ) : selectedDoctor?.currentDoctorStatus === "CLOSED" ? (
                  <Close />
                ) : selectedDoctor?.currentDoctorStatus === "AWAY" ? (
                  <Timing />
                ) : null
              ) : null}
            </div>
            <div className="w-[calc(100%_-_30px)]">
              <div className="font-medium text-gray-800">
                Dr. {selectedDoctor?.personalInfo?.name} {selectedDoctor?.personalInfo?.surname}
              </div>
              <div className="text-sm text-gray-500">
                #{selectedDoctor?.DID} • {selectedDoctor?.personalInfo?.clinicName}
              </div>
            </div>
          </div>
        ) : (
          "Search or Select Doctor"
        )}{" "}
        {!Object.keys(selectedDoctor)?.length > 0 && (
          <button className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none">
            <ArrowDown />
          </button>
        )}
        {Object.keys(selectedDoctor)?.length > 0 && (
          <button
            type="button"
            onClick={handleClearSearch}
            className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            <CloseBorder />
          </button>
        )}
      </div>

      {isOpen && (
        <div className="z-[99] absolute w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
          <input
            id="search"
            type="text"
            placeholder="Search doctor..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value.trimStart())}
            className="w-full p-2 border-b border-gray-300 focus:outline-none rounded-t-md"
          />

          <ul className="max-h-[450px] overflow-y-auto">
            {filteredDoctors?.length > 0 ? (
              filteredDoctors?.map((doctor) => (
                <li
                  key={doctor.DID}
                  onClick={() => handleSelectDoctor(doctor)}
                  className="px-4 py-2.5 cursor-pointer hover:bg-gray-100"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-[20px] h-[20px]">
                      {doctor?.currentDoctorStatus ? (
                        doctor?.currentDoctorStatus === "ACTIVE" ? (
                          <CheckedBg fill="#00C732" />
                        ) : doctor?.currentDoctorStatus === "CLOSED" ? (
                          <Close />
                        ) : doctor?.currentDoctorStatus === "AWAY" ? (
                          <Timing />
                        ) : null
                      ) : null}
                    </div>
                    <div className="w-[calc(100%_-_30px)]">
                      <div className="font-medium text-gray-800">
                        Dr. {doctor?.personalInfo?.name} {doctor?.personalInfo?.surname}
                      </div>
                      <div className="text-sm text-gray-500">
                        #{doctor?.DID} • {doctor?.personalInfo?.clinicName}
                      </div>
                    </div>
                  </div>
                </li>
              ))
            ) : (
              <li className="p-4 text-gray-500">No doctors found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchSelectDoctor;
